export const hidePage = (): void => {
    for (const id of ['js-header', 'js-root', 'js-footer']) {
        const element = document.getElementById(id);
        if (!element) {
            continue;
        }

        element.style.display = 'none';
    }
};
